import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createAppTheme } from './theme';
import { ColorModeProvider } from './context/ColorModeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

function Root() {
  const [mode, setMode] = useState(() => localStorage.getItem('colorMode') || 'light');

  useEffect(() => {
    localStorage.setItem('colorMode', mode);
  }, [mode]);

  const theme = useMemo(() => createAppTheme(mode), [mode]);
  const colorModeValue = useMemo(
    () => ({
      mode,
      toggleMode: () => setMode((m) => (m === 'light' ? 'dark' : 'light')),
    }),
    [mode]
  );

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ColorModeProvider value={colorModeValue}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ColorModeProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);


reportWebVitals();
